import React from 'react';
import {Box, Grid} from '@material-ui/core';

import djangoIcon from '../../Assets/MySkills/django.png';
import jqueryIcon from '../../Assets/MySkills/jquery.png';
import postgresqlIcon from '../../Assets/MySkills/postgresql.png';
import sassIcon from '../../Assets/MySkills/sass.png';
import mysqlIcon from '../../Assets/MySkills/mysql.png';
import postmanIcon from '../../Assets/MySkills/postman.png';
import mongodb from '../../Assets/MySkills/MongoDB.png';
import mui from '../../Assets/MySkills/mui.png';
import jiraIcon from '../../Assets/MySkills/jira.png';
import herokuIcon from '../../Assets/MySkills/heroku.png';
import CypressIcon from '../../Assets/MySkills/Cypress.png';
import StyledComponent from '../../Assets/MySkills/StyledComp.png';
import Redux from '../../Assets/MySkills/redux.webp';
import Firebase from '../../Assets/MySkills/Firebase.png';
import LinuxIcon from '../../Assets/MySkills/Linux.png';

import useStyles from './styles';
const Skills = () => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Grid container>
                <Grid item xs={12}><h2 className={classes.title}><u>My Skills</u></h2></Grid>
            </Grid>

            <Grid className={classes.container} container justifyContent="center" spacing={4}>
        
                <Grid  item xs={6} sm={3} lg={2}>
                    <Box display="flex"  flexDirection="column" alignItems='center'>
                        <i className="fab fa-html5 fa-3x red_html"></i>
                        <p className={classes.name}>HTML 5</p>
                    </Box>
                </Grid>
                <Grid item xs={6} sm={3} lg={2}>
                    <Box display="flex"  flexDirection="column" alignItems='center'>
                        <i className="fab fa-css3-alt fa-3x blue_css"></i>
                        <p className={classes.name}>CSS 3</p>
                    </Box>
                </Grid>
                <Grid item xs={6} sm={3} lg={2}>
                    <Box display="flex"  flexDirection="column" alignItems='center'>
                        <i  className="fab fa-bootstrap fa-3x blue_bootstrap"></i>
                        <p className={classes.name}>Bootstrap</p>
                    </Box>
                </Grid>
                <Grid item xs={6} sm={3} lg={2}>
                    <Box display="flex"  flexDirection="column" alignItems='center'>
                    <img className={sassIcon} src={sassIcon} alt="Sass" />
                        <p className={classes.name}>Sass</p>
                    </Box>
                </Grid>
                <Grid item xs={6} sm={3} lg={2}>
                    <Box display="flex"  flexDirection="column" alignItems='center'>
                        <img className={classes.icon} src={mui} alt="Material-UI" />
                        <p className={classes.name}>Material-UI</p>
                    </Box>
                </Grid>
                <Grid item xs={6} sm={3} lg={2}>
                    <Box display="flex"  flexDirection="column" alignItems='center'>
                        <img className={classes.icon} src={StyledComponent} alt="StyledComponent" />
                        <p className={classes.name}>Styled Component</p>
                    </Box>
                </Grid>
                <Grid item xs={6} sm={3} lg={2}>
                    <Box display="flex"  flexDirection="column" alignItems='center'>
                        <i  className="fab fa-js fa-3x yellow_javascript"></i>
                        <p className={classes.name}>JavaScript</p>
                    </Box>
                </Grid>
                <Grid item xs={6} sm={3} lg={2}>
                    <Box display="flex"  flexDirection="column" alignItems='center'>
                        <i style={{backgroundColor: '#1F1F1F'}} className="fab fa-react fa-3x blue_react "></i>
                        <p className={classes.name}>React</p>
                    </Box>
                </Grid>
                <Grid item xs={6} sm={3} lg={2}>
                    <Box display="flex"  flexDirection="column" alignItems='center'>
                    <img className={jqueryIcon} src={jqueryIcon} alt="jQuery" />
                        <p className={classes.name}>jQuery</p>
                    </Box>
                </Grid>
                <Grid item xs={6} sm={3} lg={2}>
                    <Box display="flex"  flexDirection="column" alignItems='center'>
                        <i className="fab fa-python fa-3x"></i>
                        <p className={classes.name}>Python</p>
                    </Box>
                </Grid>
                <Grid item xs={6} sm={3} lg={2}>
                    <Box display="flex"  flexDirection="column" alignItems='center'>
                        <img className={djangoIcon} src={djangoIcon} alt="Django" />
                        <p className={classes.name}>Django</p>
                    </Box>
                </Grid>                
                <Grid item xs={6} sm={3} lg={2}>
                    <Box display="flex"  flexDirection="column" alignItems='center'>
                        <img className={postmanIcon} src={postmanIcon} alt="Postman" />
                        <p className={classes.name}>Postman</p>
                    </Box>
                </Grid>
                <Grid item xs={6} sm={3} lg={2}>
                    <Box display="flex"  flexDirection="column" alignItems='center'>
                        <img className={Redux} src={Redux} style={{width:"60px", marginTop:"-5px"}} alt="Redux" />
                        <p className={classes.name}>Redux</p>
                    </Box>
                </Grid>
                <Grid item xs={6} sm={3} lg={2}>
                    <Box display="flex"  flexDirection="column" alignItems='center'>
                        <img className={Firebase} src={Firebase} style={{width:"110px"}} alt="Firebase" />
                        <p className={classes.name}>Firebase</p>
                    </Box>
                </Grid>
                <Grid item xs={6} sm={3} lg={2}>
                    <Box display="flex"  flexDirection="column" alignItems='center'>
                        <img className={herokuIcon} src={herokuIcon} alt="Heroku" />
                        <p className={classes.name}>Heroku</p>
                    </Box>
                </Grid>
                <Grid item xs={6} sm={3} lg={2}>
                    <Box display="flex"  flexDirection="column" alignItems='center'>
                        <i className="fab fa-github fa-3x"></i>
                        <p className={classes.name}>Git/Github</p>
                    </Box>
                </Grid>
                <Grid item xs={6} sm={3} lg={2}>
                    <Box display="flex"  flexDirection="column" alignItems='center'>
                        <img className={classes.icon} src={jiraIcon} alt="Jira" />
                        <p className={classes.name}>Jira</p>
                    </Box>
                </Grid>
                <Grid item xs={6} sm={3} lg={2}>
                    <Box display="flex"  flexDirection="column" alignItems='center'>
                        <img className={classes.icon} src={LinuxIcon} style={{width:"70px", height:"60px"}} alt="Linux" />
                        <p className={classes.name}>Linux</p>
                    </Box>
                </Grid>
                <Grid item xs={6} sm={3} lg={2}>
                    <Box display="flex"  flexDirection="column" alignItems='center'>
                        <img className={classes.icon} src={CypressIcon} alt="Cypress" />
                        <p className={classes.name}>Cypress</p>
                    </Box>
                </Grid>
                <Grid item xs={6} sm={3} lg={2}>
                    <Box display="flex"  flexDirection="column" alignItems='center'>
                        <img className={classes.icon} src={mongodb} alt="MongoDB" />
                        <p className={classes.name}>MongoDB</p>
                    </Box>
                </Grid>
                <Grid item xs={6} sm={3} lg={2}>
                    <Box display="flex"  flexDirection="column" alignItems='center'>
                        <img className={mysqlIcon} src={mysqlIcon} alt="MySQL" />
                        <p className={classes.name}>MySQL</p>
                    </Box>
                </Grid>
                <Grid item xs={6} sm={3} lg={2}>
                    <Box display="flex"  flexDirection="column" alignItems='center'>
                        <img className={postgresqlIcon} src={postgresqlIcon} alt="PostgreSQL" />
                        <p className={classes.name}>PostgreSQL</p>
                    </Box>
                </Grid>
                
            </Grid>
        </div>
    );
};

export default Skills;
